export const isDevEnv = (): boolean => process.env.NODE_ENV === 'development'

export const isTestEnv = (): boolean => process.env.NODE_ENV === 'test'

export const isBrowser = () => {
  return typeof window !== 'undefined' && typeof window.document !== 'undefined'
}
